import MaintenancePage from "../MaintenancePage";
import Resource from "features/maintenance/resources/changePasswordResource";

export default function ChangePassword() {
    return <MaintenancePage resource={Resource} />;
}
